module.exports = __webpack_public_path__ + "static/media/demofilm-drawer-mf-ikon@3x.d703e7fc.png";